export default __webpack_public_path__ + "static/media/set-account-info.807f5a0c.svg";